import React from 'react'
import { isMobile } from 'react-device-detect'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'

import {
  DcBreadcrumbs,
  DcButton,
  DcFlexBox,
  DcOverlaySlider,
  DcTabs,
  PixelFlexBox,
  PixelPageContainer,
  PixelTable,
  PixelTableAction,
  Section,
  SectionContent,
} from 'pixel-base'
import { get, getDefaultOrderStatuses } from 'utils/api-routes.util'
import PenIcon from 'utils/icons/pen-icon'
import PlusIcon from 'utils/icons/plus-icon'

import AddNewStatusForm from './components/AddNewStatusForm'
import { colors } from '../../../../../../shared/pixel-base/components/styleGuide'

const breadcrumbs = [
  {
    name: 'Settings',
    active: false,
  },
  {
    name: 'Order Status',
    active: true,
  },
]
const OrderStatuses = () => {
  const [orderStatus, setOrderStatus] = React.useState<any>([])
  const [showNewModal, setShowNewModal] = React.useState(false)
  const [defaultStatuses, setDefaultStatuses] = React.useState([])
  const [editingStatus, setEditingStatus] = React.useState(false)
  const [tableLoading, setTableLoading] = React.useState(true)
  const [selectedTab, setSelectedTab] = React.useState('All')

  const readData = () => {
    setTableLoading(true)
    get('/settings/order/status-list').subscribe((res: any) => {
      setOrderStatus(res.response.data)
      setTableLoading(false)
    })
  }
  const actions = [
    {
      title: 'Edit',
      icon: (
        <Section>
          <PenIcon
            style={{ cursor: 'pointer', color: colors.primary }}
            size={18}
          />
        </Section>
      ),
      clickHandler: (row) => {
        setEditingStatus(row)
        setShowNewModal(true)
      },
    },
  ]
  const columns = [
    {
      dataField: 'status_id',
      name: 'Status Id ',
      selector: (row) => row.status_id,
      sortable: true,
    },
    {
      dataField: 'status_label',
      name: 'Status Label ',
      sortable: true,
      selector: (row) => row.status_label,
    },
    {
      dataField: 'ems_status_name',
      name: 'PixelOne Status Name',
      sortable: true,
      selector: (row) => row.ems_status_name,
    },
    {
      dataField: 'actions',
      name: 'Actions',
      sortable: true,
      selector: (row) => <PixelTableAction row={row} action={actions} />,
    },
  ]
  React.useEffect(() => {
    readData()
    getAllDefaultOrderStatuses()
  }, [])

  const getAllDefaultOrderStatuses = () => {
    getDefaultOrderStatuses().subscribe((res: any) => {
      setDefaultStatuses(res.response.data)
    })
  }

  const handleCloseModal = (data: any, action) => {
    if (action === 'add') {
      setOrderStatus([data, ...orderStatus])
    } else if (action === 'update') {
      const newStatuses = orderStatus.map((source) => {
        if (source.status_id === data.status_id) {
          return data
        }
        return source
      })
      setOrderStatus(newStatuses)
    }
    setShowNewModal(false)
  }
  const tabs = [
    { label: 'All', value: 'All' },
    { label: 'Cancelled', value: 'Cancelled' },
    { label: 'New', value: 'New' },
    { label: 'Tracking', value: 'Tracking' },
    { label: 'Complete', value: 'Complete' },
    { label: 'Processing', value: 'Processing' },
    { label: 'Returns', value: 'Returns' },
    { label: 'Post Delivery', value: 'Post Delivery' },
  ]

  const filteredOrderStatus =
    selectedTab === 'All'
      ? orderStatus
      : orderStatus &&
        orderStatus.filter(
          (status) => status.status_classification === selectedTab,
        )
  const subHeaderComponentMemo = React.useMemo(() => {
    return <PixelFlexBox></PixelFlexBox>
  }, [selectedTab, tabs])
  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer style={{ padding: '0 ' }}>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <PixelFlexBox
              padding=" 0px 20px"
              height="auto"
              alignContent="flex-start"
              justifyContent="space-between"
              alignItems="flex-end"
            >
              <DcTabs
                variant="simple"
                size="md"
                tabs={tabs}
                activeTab={selectedTab}
                handleChange={(value) => {
                  setSelectedTab(value)
                }}
              />
              <DcButton
                style={{ margin: '5px 0 5px 0' }}
                size="sm"
                variant="outline-success"
                onClick={() => {
                  setEditingStatus(false)
                  setShowNewModal(true)
                }}
                withIcon={true}
              >
                <PlusIcon size={18} /> <span>Add {!isMobile && 'Status'}</span>
              </DcButton>
            </PixelFlexBox>
          </SectionContent>
        </Section>
        <Section
          style={{
            padding: '20px',
            height: 'calc(100vh - 100px)',
            overflow: 'auto',
          }}
          isMobile={isMobile}
        >
          <SectionContent isMobile={isMobile}>
            <PixelTable
              columns={columns}
              data={filteredOrderStatus}
              progressPending={tableLoading}
              fixedHeader
              fixedHeaderScrollHeight="calc(100vh - 212px)"
              subHeaderComponent={subHeaderComponentMemo}
              subHeader
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>

      {showNewModal && (
        <DcOverlaySlider
          width="40%"
          title={`${editingStatus ? 'Update' : 'Create'} Status`}
          onClose={() => setShowNewModal(false)}
          isOpen={showNewModal}
        >
          <SectionContent>
            {showNewModal && (
              <AddNewStatusForm
                handleClose={handleCloseModal}
                defaultStatuses={defaultStatuses}
                editingStatus={editingStatus}
              />
            )}
          </SectionContent>
        </DcOverlaySlider>
      )}
    </>
  )
}

export default OrderStatuses
